<template>
  <div>
    <el-row class="movie-list">
      <el-col :md="20">
        <el-row>
          <h2>我的在线会话</h2>
          <el-button
            size="mini"
            type="success"
            icon="el-icon-refresh"
            @click="getData"
          >刷新</el-button>
          <el-button
            size="mini"
            type="success"
            icon="el-icon-refresh"
            @click="tokenRefresh"
          >刷新 token</el-button>
        </el-row>
        <el-card>
          <el-table
            :data="dataList"
            :show-header="true"
            border
            style="width: 100%"
          >
            <el-table-column
              prop="loginAt"
              label="登入时间"
            />
            <el-table-column
              prop="loginIp"
              label="IP"
            />
            <el-table-column
              prop="location"
              label="位置"
            />
            <el-table-column
              prop="userAgent"
              label="设备"
            />
            <el-table-column
              prop="status"
              label="状态"
            />
            <el-table-column
              label="操作"
            >
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  @click="logout(scope.row)"
                >登出</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getSessionList, logoutSession, refreshToken } from '@/api/account'
import store from '@/store'
import Vue from 'vue'

export default {
  name: 'MyRecord',
  data() {
    return {
      dataList: []
    }
  },
  created() {
    document.title = '我的在线会话'
    this.getData()
  },
  methods: {
    getData() {
      getSessionList().then(resp => {
        if (resp.code === 0) {
          this.dataList = resp.data
        } else {
          this.$message.error(resp.msg)
        }
      })
    },
    tokenRefresh() {
      refreshToken().then(resp => {
        const newAccessToken = resp.data.accessToken
        // 更新 Vuex 内存中的 Access Token
        store.commit('SET_TOKEN', newAccessToken)
      })
    },
    logout(row) {
      logoutSession({ loginId: row.loginId }).then(resp => {
        if (resp.code === 0) {
          if (row.currentDevice) {
            Vue.$cookies.remove('refresh_token')
            store.commit('USER_LOGOUT')
          }

          this.getData()
        } else {
          this.$message.error(resp.msg)
        }
      })
    }
  }
}
</script>

<style scoped>
/*处于手机屏幕时*/
@media screen and (max-width: 768px) {
  .movie-list {
    padding-top: 8px;
    padding-left: 0.5%;
    padding-right: 0.5%;
  }
}

.movie-list {
  padding-top: 15px;
  padding-left: 6%;
  padding-right: 6%;
}
</style>
